import axios from 'axios'

export const customAxios = axios.create(
    {
        baseURL: process.env.REACT_APP_BACKEND_HOST,
    }
)

customAxios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 511 && window.location.pathname !== '/sessione-scaduta') {
            window.location.href = '/sessione-scaduta';
        }else {
          console.error('Errore nella richiesta:', error.message)
        }
        return Promise.reject(error);
    });